import React, { useImperativeHandle, forwardRef, useRef, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Helmet } from "react-helmet";
import { Link } from 'react-router-dom';


const PageHeader     = forwardRef((props, ref) => { 
    return  <>
        <Helmet><title>{props.title}</title></Helmet>
        <div className="page_title m0 row ">
            <div className='col-sm-12'>
                <div className='row '>
                    <div className='col-sm-6'>
                        <h3 className='mb-0'>{props.name}</h3>
                    </div>
                    <div className='col-sm-6'>
                        <div className='text-end d-flex align-items-center justify-content-end mt10'>
                            {props.rightTopHeadingJsx ? props.rightTopHeadingJsx : null}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </>
});

export default PageHeader;